import { initSupabaseClient } from 'greenback-shared/lib/supabase';

const supabase = initSupabaseClient({
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
  supabaseAnonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  storageKey: 'pyetro-backoffice-auth',
  // Moves any session still stored under the pre-rename key, so renaming it
  // does not sign existing users out. Remove once no live session predates it.
  migrateFromStorageKey: 'greenback-backoffice-auth',
});

export default supabase;
